//region block: pre-declaration
//endregion
function get_fullName(_this__u8e3s4) {
  return _this__u8e3s4.j88_1 + ' ' + _this__u8e3s4.k88_1;
}
//region block: exports
export {
  get_fullName as get_fullName2ompl3bj5l3sh,
};
//endregion

//# sourceMappingURL=User.ext.shared.mjs.map
